import 'bootstrap-colorpicker/dist/js/bootstrap-colorpicker';

'use strict';

var ad_colorPicker = function () {
  var self = this;

  self.init();
  self.bind();
};

ad_colorPicker.prototype.init = function () {
  var self = this;

  // console.log('init ad_colorPicker');

  self.init_color();

};

ad_colorPicker.prototype.bind = function () {
  var self = this;

  // console.log('bind ad_colorPicker');

  jQuery(document).arrive('.ad_colorPicker', self.init_color);

};

ad_colorPicker.prototype.init_color = function () {
  //var self = this;

  // console.log('init_color');

  jQuery('.ad_colorPicker').each(function (/*index*/) {
    var element = jQuery(this);

    var colorPicker = element.find('.ad_colorPicker_el_container');

    if (element.hasClass('st_mounted') === false) {

      var customClass = 'ad_colorPickerMenu';
      var container = false;
      var align = 'right';
      var colorSelectors = null;

      if (element.hasClass('ly_block') === true) {
        customClass = customClass + ' ' + 'ly_block';

        // container = element.closest('.ad_colorPicker__el_container');

        align = 'left';

        colorSelectors = {
            '#003D6B': '#003D6B',
            '#4c7797': '#4c7797',
            '#9EBFC7': '#9EBFC7',
            '#D8E5E9': '#D8E5E9',
            '#E07C63': '#E07C63',
            '#7F7F7F': '#7F7F7F',
            '#E7EDEE': '#E7EDEE',
            '#F2F5F6': '#F2F5F6',
            '#000000': '#000000',
            '#4C4C4C': '#4C4C4C'
        };

      }

      colorPicker.colorpicker({
        customClass: customClass,
        align: align,
        container: container,
        colorSelectors: colorSelectors,
        sliders: {
            saturation: {
                maxLeft: 200,
                maxTop: 200
            },
            hue: {
                maxTop: 200
            },
            alpha: {
                maxTop: 200
            }
        },
        template: '<div class="colorpicker dropdown-menu">' +
          '<div class="colorpicker-saturation"><i><b></b></i></div>' +
          '<div class="colorpicker-hue"><i></i></div>' +
          // '<div class="colorpicker-alpha"><i></i></div>' +
          '<div class="colorpicker-color"><div /></div>' +
          '<div class="colorpicker-selectors"></div>' +
          '</div>'
      });

      element.addClass('st_mounted');
    }

  });
};





jQuery( document ).ready(function() {

  window.ad_colorPicker = new ad_colorPicker();

});


